const eventClicButtonLoginSignUp = (params) => {
  if (typeof window !== 'undefined' && params) {
    (window as any)?.dataLayer?.push({
      event: 'generalEvent',
      eventName: 'header_masuk_daftar_button',
      eventCategory: 'header & footer navigation',
      eventLabel: params,
    });
  }
};
export default eventClicButtonLoginSignUp;
